import { Content } from "../../squidex";

export class ArticleCategoryModel extends Content {
    constructor(current?: Content) {
        super(current);
    }
}
